import { QueryClient } from "@tanstack/react-query";

export const clearCacheAfterPriceOverrideMutation = (queryClient: QueryClient) => {
	queryClient.invalidateQueries({ queryKey: ["collection"] });
	queryClient.invalidateQueries({ queryKey: ["collections"] });
	queryClient.invalidateQueries({ queryKey: ["collectionsPerformanceDelta"] });
	queryClient.invalidateQueries({ queryKey: ["transactionSummaries"] });
	queryClient.invalidateQueries({ queryKey: ["dashboardCurrentPosition"] });
	queryClient.invalidateQueries({ queryKey: ["dashboardHistoricalPositions"] });
	queryClient.invalidateQueries({ queryKey: ["dashboardPerformanceDeltas"] });
	queryClient.invalidateQueries({ queryKey: ["collectionHistoricalPositions"] });
};
